import { Route, Routes, matchPath, useLocation, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { useEffect } from "react"
import { Layout } from "antd"
import * as Styles from './styles'
import { Sidebar } from "src/components/Sidebar"
import { BreadCrumb } from "src/components/BreadCrumb"
import { SideMenu } from "src/components/Drawer"
import { toggleDrawerOpenStatus } from "src/components/Sidebar/state/action"
import { Navbar } from "src/components/Navbar"
import { Footer } from "src/components/Footer"
import { Dashboard } from "src/features/Dashboard"
import { Urls } from "src/common/urls"
import { getSessionData } from "src/session/sessionStore"
import { loginSuccess } from "src/features/Security/state/action"
import { User } from "src/common/models/user"
import { RootState } from "src/state/reducer"
import { Company } from "src/common/models/company"
import { getCompanyByIdApi } from "src/common/state/action"
import { Customers } from "src/features/Customer/Customers/index"
import { CreateCustomer } from "src/features/Customer/CreateCustomer"
import { Services } from "src/features/Service/Services/Services"
import { CreateService } from "src/features/Service/CreateService"
import { ServiceCategories } from "src/features/Service/ServiceCategories"
import { CreateServiceContract } from "src/features/ServiceContract/CreateServiceContract"
import { ServiceContracts } from "src/features/ServiceContract/ServiceContracts"
import { ServiceContractDebits } from "src/features/ServiceContractDebit/ServiceContractDebits"
import { CashboxStatementRecords } from "src/features/CashboxStatement/CashboxStatementRecords"
import { Settings } from "src/features/Settings/Settings"
import { ContractPayments } from "src/features/CustomerPayment/ContractPayments"
import { CashboxCategories } from "src/features/CashboxStatement/CashboxCategories"
import { ExpenditureRecords } from "src/features/Expenditure/ExpenditureRecords"
import { CreateExpenditureRecord } from "src/features/Expenditure/CreateExpenditureRecord"
import { PayableContracts } from "src/features/PayableContract/PayableContracts"
import { CreatePayableContract } from "src/features/PayableContract/CreatePayableContract"
import { PayableContractDebits } from "src/features/AccountPayable/PayableContractDebits"
import { Users } from "src/features/User/Users"
import { CreateUser } from "src/features/User/CreateUser"
import { Home } from "src/features/Home"
import { CustomerProfile } from "src/features/Customer/CustomerProfile"
import { PayableContractDetail } from "src/features/PayableContract/PayableContractDetail"
import { ServiceContractDetail } from "src/features/ServiceContract/ServiceContractDetail"
import { PayableContractPayments } from "src/features/AccountPayable/PayableContractPayments"
import { CreateIncomeRecord } from "src/features/Income/CreateIncomeRecord"
import { IncomeRecords } from "src/features/Income/IncomeRecords"
import { Chat } from "src/features/Chat"
import { CreateQuotation } from "src/features/Quotation/CreateQuotation"
import { QuotationRecords } from "src/features/Quotation/QuotationRecords"
import { QuotationTemplates } from "src/features/Quotation/QuotationTemplates"

interface ReduxProps {
    user?: User
    company?: Company
}

export const AdminRouter = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()

    const isServiceContractMode: boolean = Boolean(
        matchPath(Urls.FRONTEND.SERVICE_CONTRACT.CREATE, location.pathname) ||
        matchPath(Urls.FRONTEND.SERVICE_CONTRACT.EDIT, location.pathname)
    )

    const reduxProps: ReduxProps = useSelector((state: RootState) => ({
        user: state.security.user,
        company: state.common.company,
    }))

    useEffect(() => {
        if (!reduxProps.user) {
            const user = getSessionData().user
            if (user) {
                dispatch(loginSuccess(user))
            } else {
                navigate(Urls.FRONTEND.LOGOUT)
            }
        }

        if (!reduxProps.company) {
            dispatch(getCompanyByIdApi(1))
        }

        // if (!reduxProps.settings) {
        //     dispatch(getSettings())
        // }
    }, [])

    const renderRoutes = () => {
        return <Styles.ContentContainer isServiceContractMode={isServiceContractMode}>
            <Routes>

                <Route path={Urls.FRONTEND.CUSTOMER.CUSTOMERS} element={<Customers />} />
                <Route path={Urls.FRONTEND.CHAT} element={<Chat />} />
                <Route path={Urls.FRONTEND.CUSTOMER.CREATE} element={<CreateCustomer />} />
                <Route path={Urls.FRONTEND.CUSTOMER.EDIT} element={<CreateCustomer />} />
                <Route path={Urls.FRONTEND.CUSTOMER.PROFILE} element={<CustomerProfile />} />

                <Route path={Urls.FRONTEND.SERVICE.SERVICES} element={<Services />} />
                <Route path={Urls.FRONTEND.SERVICE.CREATE} element={<CreateService />} />
                <Route path={Urls.FRONTEND.SERVICE.EDIT} element={<CreateService />} />
                <Route path={Urls.FRONTEND.SERVICE_CONTRACT.SERVICE_CONTRACTS} element={<ServiceContracts />} />
                <Route path={Urls.FRONTEND.SERVICE_CONTRACT.DETAIL} element={<ServiceContractDetail />} />
                <Route path={Urls.FRONTEND.SERVICE_CONTRACT_DEBIT.SERVICE_CONTRAC_DEBITS} element={<ServiceContractDebits />} />
                <Route path={Urls.FRONTEND.CASHBOX_STATEMENT.RECORDS} element={<CashboxStatementRecords />} />
                <Route path={Urls.FRONTEND.SERVICE_CONTRACT_DEBIT_PAYMENTS.SERVICE_CONTRAC_DEBITS} element={<ContractPayments />} />
                <Route path={Urls.FRONTEND.EXPENDITURE_RECORD.RECORDS} element={<ExpenditureRecords />} />
                <Route path={Urls.FRONTEND.EXPENDITURE_RECORD.CREATE} element={<CreateExpenditureRecord />} />
                <Route path={Urls.FRONTEND.INCOME_RECORD.CREATE} element={<CreateIncomeRecord />} />
                <Route path={Urls.FRONTEND.INCOME_RECORD.RECORDS} element={<IncomeRecords />} />
                <Route path={Urls.FRONTEND.ACCOUNT_PAYABLE.PAYABLE_CONTRACTS} element={<PayableContracts />} />
                <Route path={Urls.FRONTEND.ACCOUNT_PAYABLE.CREATE} element={<CreatePayableContract />} />
                <Route path={Urls.FRONTEND.PAYABLE_CONTRACT_DEBIT.PAYABLE_CONTRACT_DEBITS} element={<PayableContractDebits />} />
                <Route path={Urls.FRONTEND.PAYABLE_CONTRACT.EDIT} element={<CreatePayableContract />} />
                <Route path={Urls.FRONTEND.PAYABLE_CONTRACT.DETAIL} element={<PayableContractDetail />} />
                <Route path={Urls.FRONTEND.PAYABLE_CONTRACT_DEBIT_PAYMENTS.PAYABLE_CONTRACT_PAYMENTS} element={<PayableContractPayments />} />

                <Route path={Urls.FRONTEND.SERVICE_CONTRACT.EDIT} element={<CreateServiceContract />} />

                <Route path={Urls.FRONTEND.SERVICE_CATEGORY.SERVICE_CATEGORIES} element={<ServiceCategories />} />
                <Route path={Urls.FRONTEND.CASHBOX_CATEGORY.RECORDS} element={<CashboxCategories />} />
                <Route path={Urls.FRONTEND.USER.USERS} element={<Users />} />
                <Route path={Urls.FRONTEND.USER.CREATE} element={<CreateUser />} />
                <Route path={Urls.FRONTEND.USER.EDIT} element={<CreateUser />} />

                <Route path={Urls.FRONTEND.SERVICE_CONTRACT.CREATE} element={<CreateServiceContract />} />

                <Route path={Urls.FRONTEND.SETTINGS} element={<Settings />} />

                <Route path={Urls.FRONTEND.DASHBOARD} element={<Dashboard />} />

                <Route path={Urls.FRONTEND.QUOTATION.CREATE} element={<CreateQuotation />} />
                <Route path={Urls.FRONTEND.QUOTATION.EDIT} element={<CreateQuotation />} />
                <Route path={Urls.FRONTEND.QUOTATION.RECORDS} element={<QuotationRecords />} />
                <Route path={Urls.FRONTEND.QUOTATION.TEMPLATES} element={<QuotationTemplates />} />

                <Route path="*" element={<Home />} />
            </Routes>
        </Styles.ContentContainer>
    }

    const renderDrawer = () => {
        return <SideMenu
            placement={'left'}
            closable={true}
            onClose={() => { dispatch(toggleDrawerOpenStatus(false)) }}
        >
            <Sidebar
                collapsible={false}
                collapsed={false}
            />
        </SideMenu>
    }

    return (
        <Layout>
            {!isServiceContractMode && <Sidebar />}
            {renderDrawer()}
            <Layout>
                {!isServiceContractMode && <Navbar />}
                {!isServiceContractMode && <BreadCrumb />}
                {renderRoutes()}
                {!isServiceContractMode && <Footer />}
            </Layout>
        </Layout>
    )
}
